import React, { useState } from 'react'
import MenuLinks from '../MenuLinks';
import LatestBlogs from '../LatestBlogs';
import FeaturedReviews from '../FeaturedReviews';
import Navbar from '../Navbar';
import SocialLinks from '../SocialLinks';
import Slide from 'react-reveal/Slide'
import Error from '../loaders/Error'
import Loading from '../loaders/Loading'
import { MDBContainer, MDBBtn, MDBIcon, MDBRow, MDBCol } from 'mdbreact'
//graphql
import { useQuery } from '@apollo/react-hooks'
import LANDING_PAGE_QUERY from '../../queries/pages/landingPage'
import SEO from '../SEO';
import FooterWhite from '../FooterWhite';
import TreeCounter from '../TreeCounter';
import SearchModal from './SearchModal';

const LandingPage = () => {
    const [show, setShow] = useState(false)
    const { data, loading, error } = useQuery(LANDING_PAGE_QUERY)

    if(loading) return <Loading/>
    if(error) return <Error/>

    const { slogan, featured_blogs, featured_product_reviews, Highlight_Section } = data.landingPage

    return (
        <>
        <SEO title="Home" description="Homepage of Minimuni, this is the blog part of us."/>
        <Navbar show={show} onClick={()=>setShow(!show)} slogan={slogan}/>
            <div style={{ display: show ? "none" : "inline" }} className="wrapper">
            <Slide bottom>
                <MenuLinks/>
            </Slide>
            <Slide bottom>
                <div className="wrapper-counter my-5 py-5">
                    <TreeCounter/>
                </div>
            </Slide>
            <Slide bottom>
                <SocialLinks/>
            </Slide>
            <Slide bottom>
                <LatestBlogs latestBlogs={featured_blogs}/>
            </Slide> 
            <Slide bottom>
                <section id="product-reviews">
                    <FeaturedReviews featuredReviews={featured_product_reviews}/>
                </section>
            </Slide>
            <MDBContainer fluid className="px-0 grey lighten-4 mt-5">
                <section className="p-5 grey lighten-4">
                    <MDBRow className="py-5 justify-content-center">
                        <MDBCol md="10" lg="8">
                            <div className="text-center">
                                <h2 style={{ lineHeight: 1.5 }} className="font-weight-bold h2-responsive">
                                    {Highlight_Section.title}
                                </h2>
                                <p className="lead">
                                    {Highlight_Section.description}
                                </p>
                                <a href={Highlight_Section.link}>
                                    <MDBBtn color="dark" className="text-capitalize">
                                        Learn More <MDBIcon fas icon="arrow-right ml-2"/>
                                    </MDBBtn>
                                </a>
                            </div>
                        </MDBCol>
                    </MDBRow>
                </section>
            </MDBContainer>
            <FooterWhite/>
            </div>
        <SearchModal onClick={()=>setShow(false)} show={show}/>
        </>
    )
}

export default LandingPage
